document.addEventListener( "DOMContentLoaded", () => {

	// If user closed the notification bar? Don't show it again for this many days
	const daysKeepNotificationBarClosed = 1;
	const timeKeepNotificationBarClosed = daysKeepNotificationBarClosed * 24 * 60 * 60 * 1000;

	const notificationBar = document.querySelector("#notificationBar");

	const showNotificationBarIfNotClossedRecently = () => {
		const lastClosedTime = localStorage.getItem("ceNotificationBarClosedTime");
		const now = new Date().getTime();

		if (notificationBar !== null && (!lastClosedTime || ( now - lastClosedTime ) > timeKeepNotificationBarClosed)) {
			notificationBar.classList.remove("hidden");
		}
	};

	showNotificationBarIfNotClossedRecently();

	const closeNotificationBar = () => {
		notificationBar.classList.add("hidden");

		const now = new Date().getTime();
		localStorage.setItem("ceNotificationBarClosedTime", now);
	};

	if (notificationBar !== null) {
		document.querySelector(".notification-bar__close").addEventListener("click", closeNotificationBar);
	}

} );
